import { useCallback, useState } from "react";
import type { SortSelection } from "@src/features/clips/types/camera";

type UseCameraSearchSortOptions = {
  initialSearchQuery?: string;
  initialSortBy?: SortSelection;
};

type UseCameraSearchSortReturn = {
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
  sortBy: SortSelection;
  setSortBy: (sortBy: SortSelection) => void;
  reset: () => void;
};

export function useCameraSearchSort({
  initialSearchQuery = "",
  initialSortBy = [],
}: UseCameraSearchSortOptions = {}): UseCameraSearchSortReturn {
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [sortBy, setSortBy] = useState<SortSelection>(initialSortBy);

  const reset = useCallback(() => {
    setSearchQuery(initialSearchQuery);
    setSortBy(initialSortBy);
  }, [initialSearchQuery, initialSortBy]);

  return {
    searchQuery,
    setSearchQuery,
    sortBy,
    setSortBy,
    reset,
  };
}
